import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['parent', 'child']

  onParentChange(_event) {
    if (!this.parentTarget.checked && this.hasChildTarget) {
      this.childTargets.forEach((el) => { el.checked = false })
    }
  }
}
